import React, {useMemo} from 'react';

import ApplePayButton from 'brandComponents/ApplePayButton';
import AmazonPayButton from 'brandComponents/core/AmazonPayButton';
import GooglePayButton from 'brandComponents/GooglePayButton';
import PayPalButton from 'brandComponents/PayPalButton';
import {useBasket} from 'brandHooks';

import {IExpressPaymentButtonsProps} from './IExpressPaymentButtons';

const ExpressPaymentButtons = ({
	classNames,
	product,
	section,
	buttonsCount = 'all',
	expressPaymentMethods,
	onClick,
	overridePayPalButtonStyles = {},
	amazonButtonConfig = {},
	isProduct = false,
}: IExpressPaymentButtonsProps) => {
	const basket = useBasket();

	const expressPaymentButtons = useMemo(() => {
		if (!basket.loaded || expressPaymentMethods.length === 0) {
			return null;
		}

		const paymentButtons = [];
		const count = buttonsCount === 'all'
			? expressPaymentMethods.length
			: buttonsCount;

		for (let i = 0; i < count; i++) {
			switch (expressPaymentMethods[i].getID()) {
				case 'PAYPAL':
					paymentButtons.push(
						<PayPalButton
							key={i}
							className={classNames}
							product={product}
							onClick={onClick}
							section={section}
							overridePayPalButtonStyles={overridePayPalButtonStyles}
						/>
					);

					break;
				case 'DW_APPLE_PAY':
					paymentButtons.push(
						<ApplePayButton
							key={i}
							classNames={classNames}
							onClick={onClick}
							isProduct={isProduct}
						/>
					);

					break;
				case 'apmgw_GooglePay':
					paymentButtons.push(
						<GooglePayButton
							key={i}
							classNames={classNames}
							onClick={onClick}
							isProduct={isProduct}
							section={section}
						/>
					);

					break;
				case 'AMAZON_PAY_V2':
					paymentButtons.push(
						<AmazonPayButton key={i} classNames={classNames} {...amazonButtonConfig} />
					);

					break;
				default:
					break;
			}
		}

		return paymentButtons;
	}, [basket.loaded, expressPaymentMethods, buttonsCount, onClick, section]);

	return <>{expressPaymentButtons}</>;
};

export default ExpressPaymentButtons;
